// extracted by mini-css-extract-plugin
export var progressBar = "_is-0";
export var progressBarInner = "_is-1";